import React from 'react';
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { BodyLarge, BodyRegular } from "@shared/ui/atoms/fonts/Body";
import Colours from "@shared/ui/atoms/Colours";
import { tablet } from "@shared/ui/atoms/MediaQueries";

export function NoHospitalityBookings(props: Props) {
  const {t} = useTranslation();
  return (
    <Wrapper>
      <Image src={"/assets/images/shapes.svg"} alt={""} />
      <Container>
        <BodyLarge weight={600}>{t('hospitality.no-bookings')}</BodyLarge>
        <BodyRegular>{t('hospitality.no-bookings-description')}</BodyRegular>
      </Container>
    </Wrapper>
  )
}

interface Props {
}

const Container = styled.div`
  padding: 32px;
  border-radius: 16px;
  width: 500px;
  min-height: 100px;
  max-width: 100%;
  margin: 0 auto 0 auto;
  background-color: ${Colours.white};
  text-align: center;
  @media (${tablet}) {
    padding: 32px 130px;
  }
`

const Image = styled.img`
  margin: 4vh auto 32px auto;
  width: 120px;
`

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`
